
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4a15094b&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DeathMember.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DeathMember.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4a15094b!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DeathMember.vue"),
  /* scopeId */
  "data-v-4a15094b",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/entry/DeathMember.vue
// module id = 727
// module chunks = 0